import React from 'react';

const Loading = ({ dataTestId }: { dataTestId?: string }) => {
  return (
    <div data-testid={dataTestId} className="h-full flex justify-center items-center">
      <h4 className="text-lg text-center font-medium text-gray-900">Loading...</h4>
    </div>
  );
};

export default Loading;
